<app-card label="Care Plan">
  <div card-buttons-desktop>
    <dx-button *ngIf="carePlan" text="Download as PDF" icon="fa fa-download" (onClick)="download()"></dx-button>
  </div>
  <div card-buttons-mobile>
    <dx-button *ngIf="carePlan" text="Download as PDF" icon="fa fa-download" (onClick)="download()"></dx-button>
  </div>
  <div #content></div>
</app-card>
